import React, { useEffect, useState } from 'react'
import useSWR from 'swr'
import { basicFetcher } from '../../utils/api/swr-fetcher'
import { type PortfolioExposureStatisticData } from '../../models/exposure-statistic/exposure-statistics-types'
import StackColumnLayout from '../../layouts/stack-column-layout'
import ExposureStatisticDataGrid from './exposure-statistic-data-grid'

const MultiExposureStatisticDataGrid: React.FC = () => {
  const [portfolios, setPortfolios] = useState<string[]>([])
  const { data, error } = useSWR<PortfolioExposureStatisticData, boolean>(
    process.env.REACT_APP_API_EXPOSURE_STATISTIC,
    basicFetcher,
    {
      shouldRetryOnError: true,
      refreshInterval: 5000
    }
  )

  useEffect(() => {
    if (error === true || data === undefined) {
      setPortfolios([])
    } else {
      setPortfolios(Object.keys(data).filter(key => key !== 'timestamp'))
    }
  }, [data, error])

  return (
    <StackColumnLayout>
      {
        portfolios.map(portfolio => <ExposureStatisticDataGrid key={`${portfolio}-exposure-data-grid`} portfolio={portfolio}/>)
      }
    </StackColumnLayout>
  )
}

export default MultiExposureStatisticDataGrid
